module.exports = __webpack_public_path__ + "img/diners.15e3eabe.svg";